import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Sparkles, Clock, Award, ArrowRight } from 'lucide-react';
import JUVQuiz from '@/components/JUVQuiz';
import { useState } from 'react';
const Quiz = () => {
  const [showQuiz, setShowQuiz] = useState(false);
  if (showQuiz) {
    return <div className="min-h-screen bg-gradient-to-br from-juv-cream-white to-juv-soft-blush py-12">
        <div className="container mx-auto px-4">
          <JUVQuiz />
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gradient-to-br from-juv-cream-white to-juv-soft-blush">
      {/* Hero Section */}
      <section className="py-20">
        <div className="container mx-auto px-4 text-center">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-4xl mx-auto">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-r from-juv-terracotta to-juv-deep-chestnut rounded-full flex items-center justify-center">
                <Sparkles className="w-8 h-8 text-white" />
              </div>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold text-juv-deep-chestnut mb-6">
              Discover Your Perfect
              <span className="bg-gradient-to-r from-juv-terracotta to-juv-deep-chestnut bg-clip-text text-transparent block">
                JUV Journey
              </span>
            </h1>
            
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Take our personalized skin assessment to receive customized treatment recommendations 
              tailored specifically for your unique beauty goals.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              <Card className="border-0 shadow-lg bg-slate-50">
                <CardContent className="p-6 text-center">
                  <Clock className="w-8 h-8 text-juv-terracotta mx-auto mb-4" />
                  <h3 className="font-semibold text-juv-deep-chestnut mb-2">Quick & Easy</h3>
                  <p className="text-sm text-gray-600">Just 3 minutes to complete</p>
                </CardContent>
              </Card>
              
              <Card className="border-0 shadow-lg bg-slate-50">
                <CardContent className="p-6 text-center">
                  <Sparkles className="w-8 h-8 text-juv-terracotta mx-auto mb-4" />
                  <h3 className="font-semibold text-juv-deep-chestnut mb-2">Personalized</h3>
                  <p className="text-sm text-gray-600">Tailored to your skin goals</p>
                </CardContent>
              </Card>
              
              <Card className="border-0 shadow-lg">
                <CardContent className="p-6 text-center bg-slate-50">
                  <Award className="w-8 h-8 text-juv-terracotta mx-auto mb-4" />
                  <h3 className="font-semibold text-juv-deep-chestnut mb-2">Expert Approved</h3>
                  <p className="text-sm text-gray-600">Backed by our medical team</p>
                </CardContent>
              </Card>
            </div>

            <Button onClick={() => setShowQuiz(true)} size="lg" className="bg-gradient-to-r from-juv-terracotta to-juv-deep-chestnut text-white px-8 py-4 text-lg hover:shadow-lg transition-all duration-300 group">
              Start Your JUV Quiz
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </motion.div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-juv-deep-chestnut mb-4">
              What You'll Discover
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our comprehensive assessment analyzes your skin concerns, lifestyle, and goals 
              to create your personalized JUV treatment plan.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[{
            title: "Skin Analysis",
            description: "Identify your primary concerns and skin type",
            icon: "🔍"
          }, {
            title: "Treatment Match",
            description: "Find the perfect treatments for your goals",
            icon: "💉"
          }, {
            title: "Routine Guidance",
            description: "Get skincare recommendations that work",
            icon: "✨"
          }, {
            title: "Expert Consultation",
            description: "Book with our recommended provider",
            icon: "👩‍⚕️"
          }].map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="text-center">
                <div className="text-4xl mb-4">{benefit.icon}</div>
                <h3 className="font-semibold text-juv-deep-chestnut mb-2">{benefit.title}</h3>
                <p className="text-sm text-gray-600">{benefit.description}</p>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
};
export default Quiz;